var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "10 2 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_1130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 3,
    width: 36,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5176 3.17313H45.4657V53.5731H10.5176V3.17313Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 3.16717C18.3505 3.16717 10.53 10.9882 10.53 20.6375C10.53 22.2422 10.7507 23.7953 11.1568 25.2712C11.5082 26.5561 12.0011 27.7838 12.6225 28.9332C12.7726 29.21 12.9309 29.4836 13.0948 29.7523L26.266 52.5663C26.2941 52.6152 26.3197 52.6665 26.3508 52.714C26.7129 53.2372 27.3157 53.5791 27.9992 53.5791C28.6841 53.5791 29.2888 53.2323 29.6504 52.7076L29.7066 52.6103L42.9018 29.7564L43.3782 28.9313C43.9985 27.7828 44.4906 26.5542 44.8438 25.2712C45.2484 23.7953 45.4693 22.2424 45.4693 20.6375C45.4693 10.9882 37.6483 3.16717 28.0003 3.16717ZM27.9992 27.9607C23.9529 27.9607 20.6733 24.6814 20.6733 20.6375C20.6733 16.5911 23.9524 13.311 27.9992 13.311C32.0448 13.311 35.3225 16.5911 35.3225 20.6375C35.3225 24.6814 32.0448 27.9607 27.9992 27.9607Z",
    fill: "#5B792E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIconSm);
export default __webpack_public_path__ + "static/media/mapMarkerIconSm.af12bd5c72c8e00767e96016eea6d25d.svg";
export { ForwardRef as ReactComponent };